/**
 * cl-list-item-icon
 *
 * A wrapper to apply List styles to cl-icon or cl-svg-icon.
 */

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ClListItemIcon extends Vue {}
